import script from "./realgrid.vue?vue&type=script&setup=true&lang=js"
export * from "./realgrid.vue?vue&type=script&setup=true&lang=js"

import "./realgrid.vue?vue&type=style&index=0&id=15094ec3&lang=css"

const __exports__ = script;

export default __exports__